export const NEGATIVE = 1;
export const NEUTRAL = 2;
export const POSITIVE = 3;

export default {
  NEGATIVE,
  NEUTRAL,
  POSITIVE
};
